// export const Store = window.sessionStorage;
export const Store = window.localStorage;
